'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sortNavigationItems(navigationItems) {
  return navigationItems.sortBy(function (item) {
    return item.position;
  });
}

var NavigationItemStore = function () {
  function NavigationItemStore(navigationItems) {
    _classCallCheck(this, NavigationItemStore);

    if (_immutable.Map.isMap(navigationItems)) {
      this.navigationItems = navigationItems;
    } else {
      this.navigationItems = new _immutable.Map(navigationItems.map(function (item) {
        return [item.id, item];
      }));
    }
  }

  _createClass(NavigationItemStore, [{
    key: 'get',
    value: function get(id) {
      return this.navigationItems.get(id);
    }
  }, {
    key: 'getRoots',
    value: function getRoots() {
      return sortNavigationItems(this.navigationItems.valueSeq().filter(function (navigationItem) {
        return !navigationItem.navigation_section_id;
      }));
    }
  }, {
    key: 'getNavigationItemsInSection',
    value: function getNavigationItemsInSection(navigationSectionId) {
      if (!navigationSectionId) {
        return this.getRoots();
      }

      return sortNavigationItems(this.navigationItems.valueSeq().filter(function (navigationItem) {
        return navigationItem.navigation_section_id === navigationSectionId;
      }));
    }
  }, {
    key: 'map',
    value: function map() {
      var _navigationItems$valu;

      return (_navigationItems$valu = this.navigationItems.valueSeq()).map.apply(_navigationItems$valu, arguments);
    }
  }, {
    key: 'update',
    value: function update(id, updater) {
      var updatedItem = updater(this.get(id));
      return new NavigationItemStore(this.navigationItems.set(id, updatedItem));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return new NavigationItemStore(this.navigationItems.delete(id));
    }
  }, {
    key: 'reposition',
    value: function reposition(id, newNavigationSectionId, newPosition) {
      var item = this.get(id);
      var itemsInSection = this.getNavigationItemsInSection(newNavigationSectionId).filter(function (sectionItem) {
        return sectionItem.id !== item.id;
      }).toList();

      var insertIndex = itemsInSection.findIndex(function (sectionItem) {
        return sectionItem.position >= newPosition;
      });
      if (insertIndex === -1) {
        insertIndex = itemsInSection.size;
      }

      var newItems = itemsInSection.insert(insertIndex, _extends({}, item, {
        navigation_section_id: newNavigationSectionId
      }));
      var newItemsWithPositions = newItems.map(function (newItem, index) {
        return _extends({}, newItem, { position: index + 1 });
      });
      var newItemsMap = new _immutable.Map(newItemsWithPositions.map(function (newItem) {
        return [newItem.id, newItem];
      }));

      return new NavigationItemStore(this.navigationItems.merge(newItemsMap));
    }
  }, {
    key: 'applySort',
    value: function applySort(newNavigationItems) {
      return new NavigationItemStore(this.navigationItems.withMutations(function (navigationItems) {
        return newNavigationItems.navigationItems.reduce(function (result, newNavigationItem) {
          return result.set(newNavigationItem.id, _extends({}, result.get(newNavigationItem.id), {
            position: newNavigationItem.position,
            navigation_section_id: newNavigationItem.navigation_section_id
          }));
        }, navigationItems);
      }));
    }
  }]);

  return NavigationItemStore;
}();

exports.default = NavigationItemStore;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/NavigationItemStore.js
// module id = 406
// module chunks = 0